"use client";
import { useMemo } from "react";
import { createClient } from "@/lib/supabase/client";
import type { TypedSupabaseClient } from "@/types";

export function useSupabase(): TypedSupabaseClient {
  return useMemo(() => createClient(), []);
}
